module.exports = __webpack_public_path__ + "static/flags/IO-36d4dd3da269b65604fe5aaff15d74b5.gif";